import {PingAction} from "../state/types";
import {PlayerElement, PlayerElementHandle} from "./PlayerElement";
import Vpaid from "./useVast/vpaid";
import {useRef} from "react";
import {useDispatch, useSelector} from "react-redux";
import {AppState} from "../state";
import equals from "fast-deep-equal";
// @ts-ignore
import ping from "../../../static/pip-radia-cz.mp3";


export const usePing = () => {
    const el = useRef<PlayerElementHandle>(null);
    const dispatch = useDispatch();
    const source = useSelector((a:AppState)=>a.source, equals);

    if (source.type === "Ping") {
        const usePingInner = () => (<div>
            <div key={'container'}>{[
                <PlayerElement key={'video'}
                               width={20}
                               height={1}
                               ref={el}
                               position={0}
                               sources={[{
                                   src: ping,
                                   type: "audio/mpeg"
                               }]}
                               volume={0.05}
                               preload={"metadata"}
                               onEnded={() => {
                                   const duration = el.current?.duration
                                   if (duration) {
                                       dispatch<PingAction>({
                                           type: "PingBegin",
                                       })
                                   }
                                   else {
                                       dispatch<PingAction>({
                                           type: "PingError",
                                       })
                                   }
                               }}
                               onError={(e) => {
                                   dispatch<PingAction>({
                                       type: "PingError"
                                   })
                               }}/>,
                <Vpaid key='vpaid'
                       scriptUrl={''}
                       complete={() => {}}
                       adStart={() => {}}
                       adPause={()=>{}}
                       adLoad={() => {}}
                       width={() => 0}
                       height={() => 0}
                       volume={0.05}
                       className={''}
                       vast={'NONE'}/>
            ]}
            </div>
        </div>);
        return usePingInner;
    }
    return false;
}